export default "__VITE_ASSET__BSsqGSK4__"